import React from 'react';
import { BaseCorpName } from 'src/components/enterprise/features/Corporate/components/Form/common/BaseCorpName/BaseCorpName';

export interface CorporateNameFieldControlProps {
  name: string;
  id: string;
}

export function CorporateNameFieldControl({
  name,
  id,
}: CorporateNameFieldControlProps): JSX.Element {
  return <BaseCorpName name={name} id={id} />;
}
